export class QualityControlPainting {
    id!: string
    job!: string
    productRequired!: string
    productName!: string
    areasApplied!: string
    preparationMethod!: string
    dftRequired!: string
    createdOn!: Date
    modifiedOn!: Date
}
